import Vuex from 'vuex'
import Vue from 'vue'

import AuthModule from './modules/auth'
import LayerModule from './modules/layer'
import GeoObjectsModule from './modules/geoobjects'
import GeoViewModule from './modules/geoview'
import UserModule from './modules/user'
import QueueModule from './modules/queue'
import SearchModule from './modules/search'
import HelpModule from './modules/help'

Vue.use(Vuex)

const AppStore = new Vuex.Store({
  strict: false,
  modules: {
    auth: AuthModule,
    layer: LayerModule,
    geoview: GeoViewModule,
    geoobject: GeoObjectsModule,
    user: UserModule,
    help: HelpModule,
    queue: QueueModule,
    search: SearchModule
  }
})

export default AppStore
